export const tableColumns = [
  {
    label: "模板名称",
    value: "name"
  },
  {
    label: "工作表",
    value: "sheetName"
  },
  {
    label: "模板描述",
    value: "desc"
  },
  {
    label: "模板文件",
    value: "file.name"
  },
  {
    label: "创建人",
    value: "creatorUser.name"
  },
  {
    label: "创建时间",
    value: "createAt"
  }
]
